import type { UseFormReturn } from 'react-hook-form';
import type { CarFormData } from '../types/car';
import { FormField } from './FormField';
import { FUEL_TYPES, TRANSMISSION_TYPES } from '@moshina-bozor/shared';

interface Props {
  form: UseFormReturn<CarFormData>;
}

export function StepTechnicalInfo({ form }: Props) {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <div className="form-step">
      <h2>Texnik ma'lumotlar</h2>

      <div className="form-row">
        <FormField label="Narxi" required error={errors.price}>
          <input
            {...register('price', { valueAsNumber: true })}
            type="number"
            placeholder="15000"
            className={errors.price ? 'error' : ''}
          />
        </FormField>

        <FormField label="Valyuta">
          <select {...register('currency')}>
            <option value="USD">$ Dollar</option>
            <option value="UZS">So'm</option>
          </select>
        </FormField>
      </div>

      <FormField label="Yurgan yo'li (km)">
        <input
          {...register('mileage', { valueAsNumber: true })}
          type="number"
          placeholder="50000"
        />
      </FormField>

      <div className="form-row">
        <FormField label="Yonilg'i" required error={errors.fuelType}>
          <select {...register('fuelType')} className={errors.fuelType ? 'error' : ''}>
            {FUEL_TYPES.map((fuel) => (
              <option key={fuel.value} value={fuel.value}>
                {fuel.label}
              </option>
            ))}
          </select>
        </FormField>

        <FormField label="Korobka" required error={errors.transmission}>
          <select {...register('transmission')} className={errors.transmission ? 'error' : ''}>
            {TRANSMISSION_TYPES.map((trans) => (
              <option key={trans.value} value={trans.value}>
                {trans.label}
              </option>
            ))}
          </select>
        </FormField>
      </div>
    </div>
  );
}
